(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ljt-collection-main-assets"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ljtCollectionTemplateReady) return;
    window.ljtCollectionTemplateReady = true;

    const lockBody = () => {
      const hasOpenDrawer = Boolean(document.querySelector('[data-ljt-filter-dialog][open]'));
      document.body.classList.toggle('ljt-collection-lock', hasOpenDrawer);
    };

    const setQuickAddState = (form, state, statusMessage = '') => {
      const button = form.querySelector('[data-ljt-quick-add-button]');
      const label = form.querySelector('[data-ljt-quick-add-label]');
      const status = form.querySelector('[data-ljt-quick-add-status]');
      if (!button || !label) return;

      const labelByState = {
        idle: button.dataset.idleLabel,
        loading: button.dataset.loadingLabel,
        success: button.dataset.successLabel,
        error: button.dataset.errorLabel,
      };

      form.dataset.state = state;
      label.textContent = labelByState[state] || labelByState.idle;
      button.disabled = state === 'loading';
      button.setAttribute('aria-busy', String(state === 'loading'));
      if (status) status.textContent = statusMessage;
    };

    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-ljt-open-filters]');
      if (openButton) {
        const root = openButton.closest('.ljt-collection');
        const dialog = root?.querySelector('[data-ljt-filter-dialog]');
        if (dialog && typeof dialog.showModal === 'function') {
          openButton.setAttribute('aria-expanded', 'true');
          dialog.showModal();
          lockBody();
        }
      }

      const closeButton = event.target.closest('[data-ljt-close-filters]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-ljt-filter-dialog]');
        dialog?.close();
      }
    });

    document.addEventListener('click', (event) => {
      const dialog = event.target.closest('[data-ljt-filter-dialog]');
      if (dialog && event.target === dialog) dialog.close();
    });

    document.addEventListener('close', (event) => {
      if (!event.target.matches('[data-ljt-filter-dialog]')) return;
      const root = event.target.closest('.ljt-collection');
      root?.querySelectorAll('[data-ljt-open-filters]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      lockBody();
    }, true);

    document.addEventListener('change', (event) => {
      const field = event.target.closest('[data-ljt-auto-submit]');
      if (!field?.form) return;
      if (typeof field.form.requestSubmit === 'function') {
        field.form.requestSubmit();
      } else {
        field.form.submit();
      }
    });

    document.addEventListener('toggle', (event) => {
      const facet = event.target.closest('.ljt-collection-facets--desktop [data-ljt-facet]');
      if (!facet?.open) return;
      facet.parentElement.querySelectorAll('[data-ljt-facet][open]').forEach((item) => {
        if (item !== facet) item.removeAttribute('open');
      });
    }, true);

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-ljt-quick-add-form]');
      if (!form) return;

      event.preventDefault();
      if (form.dataset.state === 'loading') return;

      const button = form.querySelector('[data-ljt-quick-add-button]');
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData(form);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        const sections = cart.getSectionsToRender().map((section) => section.id);
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        cart.setActiveElement?.(button);
      }

      setQuickAddState(form, 'loading');

      try {
        const endpoint = window.routes?.cart_add_url || form.action;
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });
        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || button.dataset.errorLabel);
        }

        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'ljt-collection',
            productVariantId: formData.get('id'),
          });
        }

        if (cart && typeof cart.renderContents === 'function' && result.sections) {
          cart.classList.remove('is-empty');
          cart.renderContents(result);
        }

        setQuickAddState(form, 'success', button.dataset.successLabel);
        window.setTimeout(() => {
          if (form.isConnected) setQuickAddState(form, 'idle');
        }, 2200);
      } catch (error) {
        const message = error instanceof Error ? error.message : button.dataset.errorLabel;
        setQuickAddState(form, 'error', message);
        window.setTimeout(() => {
          if (form.isConnected) setQuickAddState(form, 'idle');
        }, 3600);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
